module.exports = __webpack_public_path__ + "static/media/Quentin Tarantino Headshot New_1602612099771.79f3d2b9.png";